export default __webpack_public_path__ + "static/media/HipsterRacism.0d8da563.pdf";